var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 315.6304016 315.6152039",
    style: {
      enableBackground: "new 0 0 315.6304016 315.6152039"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BCAD"
    },
    d: "M246.1525879,241.4376068c-12.294281,0.0445557-24.0963745-4.8267822-32.7799988-13.5299988 l-47.3500061-47.3800049c-3.4793243-3.3270264-8.9606781-3.3270264-12.4400024,0l-47.5099945,47.5099945 c-8.678299,8.7160187-20.4803848,13.6017609-32.7800064,13.5700226H64.022583l60,59.9999847 c18.7368774,18.697052,49.0731201,18.697052,67.8099976,0l60.1199951-60.1299896L246.1525879,241.4376068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BCAD"
    },
    d: "M73.3025818,73.9975967c12.2998352-0.0328445,24.1023254,4.8530579,32.7799988,13.5699997 l47.5099945,47.5200043c3.4383087,3.4277191,9.0016937,3.4277191,12.4400024,0l47.3399963-47.340004 c8.6709595-8.7281723,20.4769592-13.6191254,32.7799988-13.5800018h5.6999969l-60.1199799-60.1199913 c-18.7182465-18.725214-49.0721741-18.7308578-67.7973938-0.0126038c-0.0042038,0.0042-0.0084076,0.0084-0.0126038,0.0126038 L64.022583,73.9975967H73.3025818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BCAD"
    },
    d: "M301.5827942,123.9076004l-36.3300171-36.3300018 c-0.819397,0.3348999-1.6948547,0.5113525-2.5799866,0.5199966h-16.5200043 c-8.5965271,0.0215149-16.8370514,3.4356003-22.9299927,9.5L175.882782,144.907608 c-8.8771667,8.8610687-23.2528381,8.8610687-32.1300049,0l-47.519989-47.4900055 c-6.0913086-6.0680695-14.3320389-9.4858322-22.9300003-9.5100021H53.0227852 c-0.8357925-0.0188217-1.6617393-0.1846848-2.4399986-0.4899979l-36.5600014,36.4899979 c-18.6970482,18.7368851-18.6970482,49.0731277,0,67.8100052l36.4799995,36.4799957 c0.7765884-0.3109589,1.603569-0.4770355,2.4399986-0.4900055h20.3600044 c8.5977402-0.0252533,16.8380737-3.4428406,22.9300003-9.5099945l47.5099945-47.5099945 c8.5899963-8.5800018,23.5599976-8.5800018,32.1399994,0l47.3399963,47.3300018 c6.0929413,6.0644073,14.3334656,9.4784851,22.9300079,9.5h16.5200043c0.8854065,0.0061951,1.761322,0.1827393,2.5799866,0.5200043 l36.3300171-36.3300018c18.7252197-18.7182465,18.7308655-49.0721741,0.0126038-67.7974014 c-0.0042114-0.0041962-0.0083923-0.0084076-0.0126038-0.0126038"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.4c41dd67.svg";
export { ForwardRef as ReactComponent };